<template>
  <div v-if="isNew" class="content">
    <card class="text-left">
      <div class="row">
        <div class="col-sm-4">
          <div class="row">
            <div class="col-md-12 text-left">
              <ArtistSelect class="artist-selection" @memberChangeEvent="getArtistInfo" :show-members="false" />
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <h4 class="card-title text-left">닉네임</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="닉네임" v-model="nickname">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
          </div>
        </div>
        <!--        <div class="col-sm-4">-->
        <!--          <BlipFileUploadZone :upload-category="1" :maxFiles="1" :fileUrl="imageFileUrl" @onChangeFileIds="onFileIdChange" />-->
        <!--        </div>-->
        <div class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="addUser" type="success">유저추가</base-button>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
  <div v-else class="content">
    <card class="text-left">
      <div class="row">
        <div class="col-sm-2">
          <h4 class="card-title text-left">아티스트</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-select @change="getData" class="col-md-12 select-primary" size="large" placeholder="아티스트" v-model="unitId">
                <el-option v-for="option in units" class="select-primary" :value="option.unitId" :label="option.unitName" :key="option.unitName"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="showModal" type="danger">유저제재</base-button>
            </div>
          </div>
        </div>
        <div v-if="!isSuperBlip" class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="setSuperBlip" type="success">슈퍼블립부여</base-button>
            </div>
          </div>
        </div>
        <div v-else class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="removeSuperBlip" type="danger">슈퍼블립뺏기</base-button>
            </div>
          </div>
        </div>
        <div v-if="!isContentAdmin" class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="setContentAdmin" type="success">컨텐츠어드민부여</base-button>
            </div>
          </div>
        </div>
        <div v-else class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="removeContentAdmin" type="danger">컨텐츠어드민뺏기</base-button>
            </div>
          </div>
        </div>
        <div v-if="!isOfficial" class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="setOfficial" type="success">오피셜계정부여</base-button>
            </div>
          </div>
        </div>
        <div v-else class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="removeOfficial" type="danger">오피셜계정뺏기</base-button>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="showSubscriptionModal" type="success">구독부여</base-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <h4 class="card-title text-left"></h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button class="col-md-12" @click="addFollowableTicket" type="success">팔로우 티켓 부여</base-button>
          </div>
        </div>
      </div>

      <div v-if="isContentAdmin" class="row">
        <div class="col-sm-2">
          <div class="row">
            <div class="col-md-12 text-left">
              <ArtistSelect class="artist-selection" @memberChangeEvent="getArtistNewUnits" :show-members="false" />
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <h4 class="card-title text-left">닉네임</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="닉네임" v-model="newNickname">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="addArtistUnit" type="success">팔로우추가</base-button>
            </div>
          </div>
        </div>
      </div>
    </card>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">기본 정보</h4>
      <card class="text-left">
        <div class="row">
          <label class="col-sm-2 col-form-label">유저 ID</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">{{ userId }}</p>
            </base-input>
          </div>
        </div>
        <div class="row" v-if="unitId">
          <label class="col-sm-2 col-form-label">유저 SEGMENT</label>
          <div class="col-sm-10" v-if="segment.segment">
            <base-input>
              <p class="form-control-static">{{ segment.segment }} ({{ segment.date }})</p>
            </base-input>
          </div>
          <div v-else class="col-sm-10">
            <base-input>
              <p class="form-control-static">정보없음</p>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">유저 이름</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">{{ userDetail.userName }}</p>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">이메일</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">{{ userDetail.email }}</p>
            </base-input>
          </div>
        </div>
        <div class="row" v-if="!unitId">
          <label class="col-sm-2 col-form-label">휴대폰인증</label>
          <div class="col-sm-2">
            <base-input>
              <p class="form-control-static" v-if="userDetail.verified === 1">O</p>
              <div v-else>
                <base-input placeholder="휴대폰 번호 입력" v-model="userDetail.phoneNumber" />
              </div>
            </base-input>
          </div>
          <base-button v-if="userDetail.verified === 1" class="col-sm-2" @click="removePhone" type="default">번호삭제</base-button>
          <base-button v-else class="col-sm-2" @click="savePhoneNumber" type="success">번호저장(주의)</base-button>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">닉네임</label>
          <div class="col-sm-10">
            <base-input v-if="isContentAdmin && unitId">
              <base-input placeholder="닉네임" v-model="userDetail.nickname">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </base-input>
            <base-input v-else>
              <p class="form-control-static">{{ userDetail.nickname }}</p>
            </base-input>
          </div>
        </div>
        <div v-if="!unitId" class="row">
          <label class="col-sm-2 col-form-label">성별</label>
          <div class="col-sm-4">
            <base-input>
              <base-input placeholder="성별" v-model="userDetail.gender">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </base-input>
          </div>
          <base-button class="col-sm-2" @click="setGender" type="default">성별수정</base-button>
        </div>
        <div v-if="!unitId" class="row">
          <label class="col-sm-2 col-form-label">생년</label>
          <div class="col-sm-4">
            <base-input>
              <base-input placeholder="생년" v-model="userDetail.birthYear">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </base-input>
          </div>
          <base-button class="col-sm-2" @click="setBirthYear" type="default">생년수정</base-button>
        </div>
        <div v-if="userDetail.idHash" class="row">
          <label class="col-sm-2 col-form-label">공유페이지</label>
          <base-button class="col-sm-2" @click="goSharePage(userDetail.idHash)" type="default">공유페이지</base-button>
        </div>
        <div v-if="!unitId" class="row">
          <label class="col-sm-2 col-form-label">국적코드</label>
          <div class="col-sm-10">
            {{ userDetail.regCountryCode }}
          </div>
        </div>
        <div v-if="!unitId" class="row">
          <label class="col-sm-2 col-form-label">언어코드</label>
          <div class="col-sm-10">
            {{ userDetail.languageCode }}
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">팔로우시작일</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">{{ userDetail.followingTime | formatDateTime }}</p>
            </base-input>
          </div>
        </div>
        <div v-if="!unitId" class="row">
          <label class="col-sm-2 col-form-label">팔로우 티켓</label>
          <div class="col-sm-10">친구초대 : {{ userDetail.friendCount }} // 전체 : {{ userDetail.followableCount }}</div>
        </div>
        <div class="row" v-if="!unitId">
          <label class="col-sm-2 col-form-label">구독</label>
          <div class="col-sm-10" v-if="userDetail.subscription">
            <base-input>
              <p class="form-control-static">
                {{ userDetail.subscription.startTime | formatDateTime }} ~ {{ userDetail.subscription.endTime | formatDateTime }} ({{
                  userDetail.subscription.platform
                }})
              </p>
            </base-input>
            <base-button class="col-sm-2" @click="goSubscriptionDashboard()">내역보기</base-button>
          </div>
          <div class="col-sm-10" v-else>X</div>
        </div>
        <div v-if="isContentAdmin && unitId" class="row">
          <label class="col-sm-2 col-form-label">프로필이미지</label>
          <div class="col-sm-10">
            <BlipFileUploadZone :upload-category="1" :maxFiles="1" :fileUrl="userDetail.profileImageId | blipImageUrl" @onChangeFileIds="onFileIdChange" />
          </div>
        </div>
        <div v-if="userDetail.profileImageId && !isContentAdmin && !unitId" class="row">
          <label class="col-sm-2 col-form-label">프로필이미지</label>
          <div class="col-sm-10">
            <img :src="userDetail.profileImageId | blipImageUrl" />
          </div>
        </div>
        <div v-if="isContentAdmin && unitId" class="col-sm-3">
          <h4 class="card-title text-left">&nbsp;</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-button class="col-md-12" @click="setUserProfile" type="success">저장</base-button>
            </div>
          </div>
        </div>
      </card>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">활동 이력</h4>
      <card class="text-left">
        <div class="row">
          <label class="col-sm-2 col-form-label">팔로잉/팔로워</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">{{ userDetail.followingCount }} / {{ userDetail.followerCount }}</p>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">갤러리(게시수/총작성수)</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">
                {{ userDetail.collectionCount }} / {{ userDetail.collectionTotalCount }} &nbsp;
                <base-button v-if="unitId" class="col-md-2" @click="showUserCollection()" type="info">갤러리보기</base-button>
              </p>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">토픽(게시수/총작성수)</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">
                {{ userDetail.topicCount }} / {{ userDetail.topicTotalCount }}&nbsp;
                <base-button v-if="unitId" class="col-md-2" @click="showUserTopic()" type="info">토픽보기</base-button>
              </p>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">팬로그(게시수/총작성수)</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">
                {{ userDetail.fanLogCount }} / {{ userDetail.fanLogTotalCount }} &nbsp;
                <base-button v-if="unitId" class="col-md-2" @click="showUserFanLog()" type="info">팬로그보기</base-button>
              </p>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">스케줄제보(처리완료/총제보)</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">{{ userDetail.scheduleSuggestionCount }} / {{ userDetail.scheduleSuggestionTotalCount }}</p>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">아티스트보드제보(처리완료/총제보)</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">{{ userDetail.artistBoardSuggestionCount }} / {{ userDetail.artistBoardSuggestionTotalCount }}</p>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">핀(갤러리/토픽/트렌드)</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">{{ userDetail.collectionPinCount }} / {{ userDetail.topicPinCount }} / {{ userDetail.contentPinCount }}</p>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">차단당한수</label>
          <div class="col-sm-10">
            <base-input>
              <p class="form-control-static">{{ userDetail.blockedCount }}</p>
            </base-input>
          </div>
        </div>
      </card>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">신고 이력</h4>
      <card class="text-left">
        <div class="row">
          <el-table :data="reportedList">
            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
            <el-table-column :min-width="100" align="right" label="게시물확인">
              <div slot-scope="props">
                <base-button
                  @click.native="goContentPage(props.row.namespace, props.row.contentId, props.row.unitId)"
                  class="icon-simple-delete btn-link"
                  type="warning"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-pencil" />
                </base-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">유저신고 이력</h4>
      <card class="text-left">
        <div class="row">
          <el-table :data="userReportedList">
            <el-table-column
              v-for="column in userReportTableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            />
            <el-table-column :min-width="100" align="right" label="게시물확인">
              <div slot-scope="props" v-if="props.row.namespace">
                <base-button
                  @click.native="goContentPage(props.row.namespace, props.row.contentId, props.row.unitId)"
                  class="icon-simple-delete btn-link"
                  type="warning"
                  size="sm"
                  icon
                >
                  <i class="tim-icons icon-pencil" />
                </base-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">제재 이력</h4>
      <card class="text-left">
        <div class="row">
          <el-table :data="blockedList">
            <el-table-column v-for="column in blockedTableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
            <el-table-column :min-width="50" align="right" label="삭제">
              <base-button slot-scope="props" @click.native.stop="deleteBlock(props.row.id)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-send" />
              </base-button>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">정지 이력</h4>
      <card class="text-left">
        <div class="row">
          <el-table :data="bannedList">
            <el-table-column v-for="column in blockedTableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
            <el-table-column :min-width="50" align="right" label="삭제">
              <base-button slot-scope="props" @click.native.stop="deleteBan(props.row.id)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-send" />
              </base-button>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">닉네임 변경 이력</h4>
      <card class="text-left">
        <div class="row">
          <el-table :data="followingHistory">
            <el-table-column
              v-for="column in followingHistoryTableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            />
            <el-table-column :min-width="50" align="right" label="프로필사진">
              <img slot-scope="props" :src="props.row.profileImageFile" />
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
    <div class="basic-info-section">
      <h4 class="section-title pull-left">젬 구매내역 (PG+IAP 통합)</h4>
      <card class="text-left">
        <div class="row">
          <el-table :data="gemPurchaseList">
            <el-table-column
              v-for="column in gemPurchaseTableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            />
          </el-table>
        </div>
      </card>
    </div>
    <UserDetailModal
      :key="componentKey"
      :userId="userId"
      :shouldShow="userDetailModal.show"
      :onConfirm="onUserDetailModal"
      :onCancel="onCancelModal"
    ></UserDetailModal>
    <UserSubscriptionModal
      :key="componentKey + 1000"
      :userId="userId"
      :shouldShow="subscriptionModal.show"
      :onConfirm="onSubscriptionModal"
      :onCancel="onSubscriptionCancelModal"
    ></UserSubscriptionModal>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { Table, TableColumn } from "element-ui";
import { BaseInput, Card } from "@/components/index";
import { BlipNamespace, BlipNamespaceOptions } from "@/common/BlipNamespace";
import UserSubscriptionModal from "./UserSubscriptionModal";
import UserDetailModal from "./UserDetailModal";
import { formatDateTime } from "@/util/DateUtils";
import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import _ from "lodash";
import { UserSanctionReasons } from "@/pages/User/UserSanctionReasons";
import Endpoints from "@/common/Endpoints";
import swal from "sweetalert2";

export default {
  components: {
    ArtistSelect,
    BlipFileUploadZone,
    BaseInput,
    Card,
    UserDetailModal,
    UserSubscriptionModal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    if (!this.$route.query.userId) {
      this.isNew = true;
    } else {
      this.userId = this.$route.query.userId;
      await this.getUserUnitFollowing();
      await this.getData();
    }
  },
  data() {
    return {
      isNew: false,
      tableColumns: [
        {
          prop: "contentId",
          label: "컨텐트ID",
          minWidth: 50,
        },
        {
          prop: "type",
          label: "타입",
          minWidth: 50,
        },
        {
          prop: "stateName",
          label: "상태",
          minWidth: 100,
        },
        {
          prop: "title",
          label: "제목",
          minWidth: 100,
        },
      ],
      userReportTableColumns: [
        {
          prop: "contentId",
          label: "컨텐트ID",
          minWidth: 50,
        },
        {
          prop: "type",
          label: "타입",
          minWidth: 50,
        },
        {
          prop: "userId",
          label: "신고자아이디",
          minWidth: 50,
        },
      ],
      blockedTableColumns: [
        {
          prop: "startTime",
          label: "시작시간",
          minWidth: 100,
        },
        {
          prop: "endTime",
          label: "종료시간",
          minWidth: 100,
        },
        {
          prop: "reason",
          label: "사유",
          minWidth: 100,
        },
        {
          prop: "description",
          label: "메모",
          minWidth: 200,
        },
      ],
      followingHistoryTableColumns: [
        {
          prop: "nickname",
          label: "닉네임",
          minWidth: 100,
        },
        {
          prop: "state",
          label: "상태",
          minWidth: 200,
        },
      ],
      gemPurchaseTableColumns: [
        { prop: "purchasedAt", label: "구매일시", minWidth: 140 },
        { prop: "orderNumber", label: "주문번호", minWidth: 100 },
        { prop: "packageName", label: "패키지", minWidth: 140 },
        { prop: "gemSummary", label: "젬", minWidth: 140 },
        { prop: "amount", label: "결제금액", minWidth: 110 },
        { prop: "channel", label: "채널", minWidth: 70 },
        { prop: "payMethod", label: "결제수단", minWidth: 110 },
        { prop: "status", label: "상태", minWidth: 110 },
      ],
      gemPurchaseList: [],
      followingHistory: [],
      nickname: null,
      imageFileUrl: null,
      imageFileId: null,
      userId: null,
      segment: {
        segment: null,
        date: null,
      },
      unitId: null,
      newUnitId: null,
      newNickname: null,
      units: [],
      roles: [],
      isSuperBlip: true,
      isContentAdmin: false,
      isOfficial: false,
      reportedList: [],
      userReportedList: [],
      blockedList: [],
      bannedList: [],
      userDetail: {},
      componentKey: 0,
      subscriptionStartTime: null,
      subscriptionEndTime: null,
      userDetailModal: {
        show: false,
      },
      subscriptionModal: {
        show: false,
      },
    };
  },

  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
    },
    async getArtistNewUnits(param) {
      this.newUnitId = param.unitId;
    },
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },
    async addUser() {
      if (this.nickname === "" || this.nickname === null) {
        Toast.error("닉네임을 입력해주세요");
        return;
      }
      const params = {
        nickname: this.nickname,
        gender: "E",
        birthYear: 2000,
        followings: [{ unitId: this.unitId, nickname: this.nickname, imageFileId: this.imageFileId }],
        additionalRoles: [`blipContentWriter`, `dummyUnitFollower/${this.unitId}`],
      };
      return this.$axios
        .post("/users/dummyUsers", params)
        .then((res) => {
          Toast.success("등록되었습니다");
          this.$router.push(`/user/userDetail?userId=${res.data.data.user.id}`);
        })
        .catch((error) => {
          Toast.error(error.response.data.error.message);
        });
    },
    async setUserProfile() {
      const params = {
        unitId: this.unitId,
        nickname: this.userDetail.nickname,
        imageFileId: this.imageFileId,
      };
      return this.$axios
        .put(`/users/${this.userId}/nickname`, params)
        .then(() => {
          Toast.success("프로필이 저장되었습니다");
          this.$router.push(`/user/userDetail?userId=${this.userId}`);
        })
        .catch((error) => {
          Toast.error(error.response.data.error.message);
        });
    },
    async addArtistUnit() {
      const units = this.units.map((unit) => unit.unitId);
      if (units.includes(this.newUnitId)) {
        Toast.error("이미 팔로우하고 있습니다");
        return;
      }
      if (this.newUnitId === null || this.newUnitId === "") {
        Toast.error("닉네임은 필수값입니다");
        return;
      }
      const params = {
        unitId: this.newUnitId,
        nickname: this.newNickname,
      };
      return this.$axios.put(`/users/${this.userId}/following`, params).then(() => {
        window.Toast.success("팔로우 정보가 추가되었습니다");
        this.newNickname = null;
        this.getUserUnitFollowing();
      });
    },
    async setGender() {
      const params = {
        gender: this.userDetail.gender,
      };
      return this.$axios.put(`/users/${this.userId}/gender`, params).then(() => {
        window.Toast.success("성별이 변경되었습니다");
      });
    },
    async removePhone() {
      swal
        .fire({
          title: "휴대폰 인증 삭제",
          text: `휴대폰 인증을 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            await this.$axios.delete(`/users/${this.userId}/phone`).then(() => {
              window.Toast.success("휴대폰 인증이 삭제되었습니다");
            });
            await this.getData();
          }
        });
    },
    async setBirthYear() {
      const params = {
        birthYear: this.userDetail.birthYear,
      };
      return this.$axios.put(`/users/${this.userId}/birthYear`, params).then(() => {
        window.Toast.success("생년 정보가 추가되었습니다");
      });
    },
    goSharePage(idHash) {
      window.open(`${Endpoints.sharePageUrl}/u/${idHash}`);
    },
    goSubscriptionDashboard() {
      window.open(`https://dashboard.blip.kr/d/9gGlC2-4z/blip-gudog-hyeonhwang?var-userId=${this.userId}`);
    },
    async getData() {
      await this.getUserRoles();
      await this.getUserDetail();
      await this.getUserContentsReportedList();
      await this.getUserBlockedList();
      await this.getUserBannedList();
      await this.getFollowingHistory();
      await this.getUserReportedList();
      await this.getGemPurchases();
    },
    async getUserUnitFollowing() {
      this.units = [];
      const params = { userId: this.userId };
      this.units.push({ unitId: null, unitName: "전체" });
      return this.$axios.get("/users/followings", { params }).then((res) => {
        this.units = this.units.concat(
          res.data.data.map((d) => {
            d.unitName += d.state !== 1 ? "(언팔)" : "";
            return d;
          })
        );
      });
    },
    async getUserDetail() {
      const params = { unitId: this.unitId, userId: this.userId };

      return this.$axios.get("/users/detail", { params }).then((res) => {
        this.userDetail = res.data.data;
        this.isOfficial = this.userDetail.isOfficial === 1;
        if (this.userDetail.profileImageId) {
          this.imageFileId = this.userDetail.profileImageId;
        }
        if (this.userDetail.subscription) {
          this.subscriptionStartTime = this.userDetail.subscription.startTime;
          this.subscriptionEndTime = this.userDetail.subscription.endTime;
        }
        if (this.userDetail.segments?.length > 0) {
          this.segment.segment = this.userDetail.segments[0].segment;
          this.segment.date = this.userDetail.segments[0].date;
        }
      });
    },
    async getUserContentsReportedList() {
      const params = { unitId: this.unitId, userId: this.userId };

      return this.$axios.get("/users/reports", { params }).then((res) => {
        this.reportedList = res.data.data.map((report) => {
          report.type = _.find(BlipNamespaceOptions, { value: report.namespace }).label;

          return report;
        });
      });
    },
    async getUserReportedList() {
      const params = { unitId: this.unitId };

      return this.$axios.get(`/users/${this.userId}/reports`, { params }).then((res) => {
        this.userReportedList = res.data.data.map((report) => {
          if (report.namespace && report.namespace > 0) {
            report.type = _.find(BlipNamespaceOptions, { value: report.namespace }).label;
          } else {
            report.type = null;
          }
          return report;
        });
      });
    },
    async getUserBlockedList() {
      const params = { unitId: this.unitId, userId: this.userId };

      return this.$axios.get("/users/blocks", { params }).then((res) => {
        this.blockedList = res.data.data.map((item) => {
          item.startTime = formatDateTime(item.startTime);
          item.endTime = formatDateTime(item.endTime);
          if (item.reason) {
            item.reason = _.find(UserSanctionReasons, { key: item.reason }).reason;
          }
          return item;
        });
      });
    },

    async getUserBannedList() {
      const params = { unitId: this.unitId, userId: this.userId };

      return this.$axios.get("/users/bans", { params }).then((res) => {
        this.bannedList = res.data.data.map((item) => {
          item.startTime = formatDateTime(item.startTime);
          item.endTime = formatDateTime(item.endTime);
          return item;
        });
      });
    },
    async getFollowingHistory() {
      if (!this.unitId) {
        return;
      }
      const params = { unitId: this.unitId, userId: this.userId };

      return this.$axios.get("/users/followingHistory", { params }).then((res) => {
        this.followingHistory = res.data.data.map((m) => {
          if (m.profileImageId) {
            m.profileImageFile = `${window.Endpoints.imageServerUrl}${m.profileImageId}`;
          }
          return m;
        });
      });
    },

    async getGemPurchases() {
      const params = { size: 100 };
      return this.$axios
        .get(`/users/${this.userId}/gem-purchases`, { params })
        .then((res) => {
          const items = (res.data.data && res.data.data.items) || [];
          this.gemPurchaseList = items.map((o) => {
            const gems = o.gems || [];
            return {
              purchasedAt: o.purchasedAt ? new Date(o.purchasedAt).toLocaleString() : "-",
              orderNumber: o.orderNumber,
              packageName: gems.map((g) => (g.packageName && g.packageName.ko ? g.packageName.ko : "-")).join(", "),
              gemSummary: gems
                .map((g) => {
                  const bonus = g.bonusGemType && g.bonusAmount ? ` (+${g.bonusGemType} ${g.bonusAmount})` : "";
                  const qty = g.quantity > 1 ? ` x${g.quantity}` : "";
                  return `${g.gemType} ${g.gemAmount}${bonus}${qty}`;
                })
                .join(", "),
              amount: `${o.totalPrice != null ? o.totalPrice.toLocaleString() : "-"}${o.currency ? " " + o.currency : ""}`,
              channel: o.channel || "-",
              payMethod: o.payMethod || "-",
              status: `${o.statusName || o.status}${o.refunded ? " (환불)" : ""}`,
            };
          });
        })
        .catch(() => {
          // 외부 S2S 프록시 실패 시 이 섹션만 비우고 페이지 전체 로드는 유지.
          this.gemPurchaseList = [];
        });
    },

    async deleteBlock(id) {
      return this.$axios.delete(`/users/${this.userId}/block`, { params: { id } }).then((res) => {
        window.Toast.success(res.data.data.message);
        this.getData();
      });
    },

    async deleteBan(id) {
      return this.$axios.delete(`/users/${this.userId}/ban`, { params: { id } }).then((res) => {
        window.Toast.success(res.data.data.message);
        this.getData();
      });
    },

    async getUserRoles() {
      return this.$axios.get(`/users/${this.userId}/roles`).then((res) => {
        this.roles = res.data.data.roles;
        this.isSuperBlip = this.roles.includes("blipAdmin");
        this.isContentAdmin = this.roles.includes("blipContentAdmin");
      });
    },

    async setSuperBlip() {
      return this.$axios.post(`/users/${this.userId}/role`, { role: "blipAdmin" }).then((res) => {
        Toast.success(res.data.data.message);
        this.getData();
      });
    },
    async removeSuperBlip() {
      const params = { role: "blipAdmin" };
      return this.$axios.delete(`/users/${this.userId}/role`, { params }).then((res) => {
        Toast.success(res.data.data.message);
        this.getData();
      });
    },
    async setContentAdmin() {
      return this.$axios.post(`/users/${this.userId}/role`, { role: "blipContentAdmin" }).then((res) => {
        Toast.success(res.data.data.message);
        this.getData();
      });
    },
    async removeContentAdmin() {
      const params = { role: "blipContentAdmin" };
      return this.$axios.delete(`/users/${this.userId}/role`, { params }).then((res) => {
        Toast.success(res.data.data.message);
        this.getData();
      });
    },
    async setOfficial() {
      return this.$axios.post(`/users/${this.userId}/official`).then((res) => {
        Toast.success(res.data.data.message);
        this.getData();
      });
    },
    async removeOfficial() {
      return this.$axios.delete(`/users/${this.userId}/official`).then((res) => {
        Toast.success(res.data.data.message);
        this.getData();
      });
    },
    goContentPage(namespace, contentId, unitId) {
      let url = null;
      if (namespace === BlipNamespace.COLLECTION) {
        url = `/collection/collectionDetail?collectionId=${contentId}&unitId=${unitId}`;
      } else if (namespace === BlipNamespace.TOPIC) {
        url = `/topic/detail/${contentId}`;
      } else if (namespace === BlipNamespace.FAN_LOG) {
        url = `/fanLog/fanLogDetail?fanLogId=${contentId}`;
      } else if (
        namespace === BlipNamespace.COLLECTION_COMMENT ||
        namespace === BlipNamespace.TOPIC_COMMENT ||
        namespace === BlipNamespace.RADAR_COMMENT ||
        namespace === BlipNamespace.CHITCHAT_COMMENT
      ) {
        url = `/comment/contents?unitId=${unitId}&namespace=${namespace}&state=1`;
      } else if (namespace === BlipNamespace.CHITCHAT) {
        url = `/chitchat/detail/${contentId}`;
      }

      this.$router.push(url);
    },
    showModal() {
      this.userDetailModal.show = true;
    },
    showSubscriptionModal() {
      this.subscriptionModal.show = true;
    },
    showUserFanLog() {
      window.open(`/fanLog/fanLogs?unitId=${this.unitId}&state=1&searchWord=${this.userDetail.nickname}&withParams=detail`);
    },
    showUserCollection() {
      window.open(`/collection/collections?unitId=${this.unitId}&state=1&gubun=2&searchWord=${this.userDetail.nickname}&searchType=2&withParams=detail`);
    },
    showUserTopic() {
      window.open(`/topic/contents?unitId=${this.unitId}&state=1&popularity=0&searchText=${this.userDetail.nickname}`);
    },
    addFollowableTicket() {
      swal
        .fire({
          title: "팔로우 티켓 부여 확인",
          text: `팔로우 티켓을 부여 하시겠습니까?\n티켓 부여 시 팔로우 가능한 아티스트가 영구적으로 1팀 늘어나며, 회수할 수 없습니다.`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "등록",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            await this.$axios.post(`/users/followable`, { userId: this.userId, historyType: "ADMIN" });
            Toast.success("부여되었습니다");
            await this.getData();
          }
        });
    },
    onUserDetailModal() {},
    onSubscriptionModal() {
      this.getData();
    },
    async onCancelModal() {
      await this.getData();
      this.userDetailModal.show = false;
    },
    async onSubscriptionCancelModal() {
      this.subscriptionModal.show = false;
    },
    async savePhoneNumber() {
      if (!this.userDetail.phoneNumber) {
        Toast.error("휴대폰 번호를 입력해주세요");
        return;
      }
      const params = { phone: this.userDetail.phoneNumber };
      await this.$axios
        .post(`/users/${this.userId}/phone`, params)
        .then(() => {
          window.Toast.success("휴대폰 번호가 저장되었습니다");
          this.getData();
        })
        .catch((error) => {
          window.Toast.error(error.response?.data?.error?.message || "저장 중 오류 발생");
        });
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
